import Settings from 'configs/Settings';

const addNewRelicRelease = () => {
  const { newrelic } = window;

  if (newrelic) {
    newrelic.addRelease('app-club-admin', Settings.packageVersion);
  }
};

const injectNewRelic = () => {
  const { newrelicConfig } = Settings || {};
  const { accountId, agentID, applicationID, licenseKey, script } =
    newrelicConfig || {};
  const scriptTag = document.createElement('script');

  window.NewRelicConf = {
    accountId,
    agentID,
    applicationID,
    licenseKey,
    injectionPercentage: 30
  };

  scriptTag.src = script;
  scriptTag.defer = true;
  scriptTag.onload = addNewRelicRelease;

  document.head.appendChild(scriptTag);
};

export { injectNewRelic };
